export type PiercingBookingJourneyStage =
  | 'STARTED'
  | 'CART'
  | 'IDENTITY'
  | 'SLOT_SELECTED'
  | 'PAYMENT_REVIEW'
  | 'CHECKOUT_REDIRECTED'
  | 'PAID';

export type PiercingBookingJourneyEventType =
  | 'ENTER_STAGE'
  | 'ADD_TO_CART'
  | 'HEARTBEAT'
  | 'PAGE_HIDDEN'
  | 'VALIDATION_ERROR';

export const PIERCING_JOURNEY_STORAGE_KEY = 'piercingBookingJourneyId';

export function mapPiercingStepToJourneyStage(
  step: number,
  cartCount: number,
): PiercingBookingJourneyStage {
  if (step === 3 || step === 4) {
    return cartCount > 0 ? 'CART' : 'STARTED';
  }
  if (step === 1 || step === 2 || step === 6) return 'IDENTITY';
  if (step === 5) return 'SLOT_SELECTED';
  if (step === 7) return 'PAYMENT_REVIEW';
  if (step === 8) return 'CHECKOUT_REDIRECTED';
  return cartCount > 0 ? 'CART' : 'STARTED';
}

export function getOrCreatePiercingJourneyId(forceNew = false): string {
  if (typeof window === 'undefined') return '';
  if (forceNew) {
    sessionStorage.removeItem(PIERCING_JOURNEY_STORAGE_KEY);
  }
  const existing = sessionStorage.getItem(PIERCING_JOURNEY_STORAGE_KEY);
  if (existing && /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(existing)) {
    return existing;
  }
  const id = typeof crypto !== 'undefined' && crypto.randomUUID
    ? crypto.randomUUID()
    : 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
        const r = (Math.random() * 16) | 0;
        const v = c === 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      });
  sessionStorage.setItem(PIERCING_JOURNEY_STORAGE_KEY, id);
  return id;
}

export function clearPiercingJourneyId(): void {
  if (typeof window === 'undefined') return;
  sessionStorage.removeItem(PIERCING_JOURNEY_STORAGE_KEY);
}
